var map = {
	"./template.default": 339,
	"./template.default.tsx": 339,
	"./template.puntcity": 1580,
	"./template.puntcity.tsx": 1580,
	"./template.sterlingparker": 1581,
	"./template.sterlingparker.tsx": 1581,
	"./template.ts": 983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2451;